<script>
    export let src = '';
    export let audioMuted = false;
    export let volume = 0.25;

    let audioElement;

    export const play = () => {
        if (audioElement && !audioMuted) {
            audioElement.volume = volume;
            audioElement.currentTime = 0;
            audioElement.play().catch(console.warn);
        }
    };

    export const stop = () => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }

</script>

{#if src && !audioMuted}
    <audio
            src={window.location.origin + '/' + src}
            bind:this={audioElement}
            preload="auto"
    ></audio>
{/if}